<template>
  <div>
    <div class="content-bottom-padded">
    <el-alert
            type="info"
            title="设置小程序业务域名信息！新增的业务域名需要先在开放平台 【第三方平台=》开发配置=》开发资料】 填写后再更新到指定小程序上"
            show-icon
    ></el-alert>

      <el-select v-model="check_wxappid" @change="wxappSelectHandle" placeholder="选择小程序"
                 style="width: 50%;">
        <el-option
                v-for="(item, index) in wx_appid_list"
                :key="index"
                :label="item.name"
                :value="item.value">
        </el-option>
      </el-select>
    </div>
    <el-col :span="3" class="content-right">
      <el-button type="primary" icon="plus" @click="handlefindList">查看业务域名</el-button>
    </el-col>

    <el-dialog title="业务域名设置" :visible.sync="dialog" :close-on-click-modal="false">
      <el-form v-model="getlist" label-width="160px">
        <el-form-item label="已经设置的业务域名">
            <el-input type="textarea" v-model="getlist"  placeholder="webview" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="新增业务域名">
          <el-input type="textarea" v-model="add_view"  placeholder="格式https://xxx.xx 多个用;分隔" ></el-input>
        </el-form-item>
        <el-button type="primary" icon="plus" @click="editHandle('add')"> 添加业务域名 </el-button>
      </el-form>
    </el-dialog>

    <router-view></router-view>
  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import timeChoose from '../../components/timechoose'
    import { WebViewSetting } from '../../api/wxa'

    export default {
        components: {
            timeChoose
        },
        data () {
            return {
                dialog:false,
                formLabelWidth: '120px',
                loading: false,
                check_wxappid:'',
                wx_appid_list:[
                    {name:'商城小程序e1b0',value:'wx47d38fb07875e1b0'},
                    {name:'多店铺商城小程序7ef2',value:'wx97aa332d3dea7ef2'}
                ],
                dialogVisibleMonitors: false,
                dialogVisibleSources: false,
                wx_content:'',
                getlist:'',
                add_view:'',
                params:{
                    action:'',
                    wxaAppId:'',
                },

                monitorsList: [],
                wxaList: [],
                weappPagesList: [],
                sourceList: [],
                selectSourceList: []
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            wxappSelectHandle () {
                this.params.wxaAppId = this.check_wxappid
            },

            handlefindList: function () {
                this.dialog = true
                this.getWebViewDomain()
            },
            getWebViewDomain:function () {
                this.params.action = 'get';

                WebViewSetting(this.params).then(response => {
                    this.getlist = response.data.data.data
                    // this.getlist = response.data.res;
                    // if(response.data.data.res.errmsg = 'ok') {
                    //     this.getlist = response.data.data.res;
                    // }
                    // this.getlist = response.data.res;
                    // alert(response.data.data.res.errmsg);
                    this.loading = false
                })
            },
            editHandle:function(req_type) {
                this.$confirm('是否更新, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.params.action = req_type
                    this.params.webView = this.add_view

                    WebViewSetting(this.params).then(response => {

                          this.getWebViewDomain()
                    })
                }).catch(() => {
                    this.params.action = ''
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })

            }

        },
        mounted () {

        }
    }
</script>
<style scoped lang="scss">
  .refresh {
    color: #38f;
    cursor: pointer;
  }
  .el-button a { color: #fff; }
  .el-transfer {
    text-align: center;
    padding: 10px 0 20px;
  }
</style>
<style type="text/css" lang="scss">
  .sources-dialog {
    .el-transfer-panel {
      text-align: left;
      width: 270px;
      .el-transfer-panel__body.is-with-footer {
        box-sizing: content-box;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// setting_webview.vue?cbf19f86